import Message from 'shared_components/message';
import { axiosLabAPI } from '../axios';
import { API_GET_METHOD } from 'global_config/constant-global';

export default async function fetchPanel() {
	let panels = [];
	try {
		const response = await axiosLabAPI({ 
			method: API_GET_METHOD, 
			url:`settings/panelexamrequest?p_panel_requesting=1`
		});
		const { data } = await response;

		// Handle new API response format
		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			panels = data.RECORDS;
		}

	} catch (e) {
		Message.error();
	}
  
	return panels;
}


export async function fetchPanellist() {
	let panels = [];
	
  try{
    const response = await axiosLabAPI({
      method: API_GET_METHOD,
			url: `settings/panelexamrequest?p_panel_requesting=1`,
		});
		
		const { data } = response;

		// Handle new API response format
		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			panels = data.RECORDS;
		}
  } 
  catch(e) {
    Message.error();
 	}
  return panels;
}

export  async function fetchExamList() {
	let exams = [];
	try {
		const response = await axiosLabAPI({ 
			method: API_GET_METHOD, 
			url: `settings/examrequestallpanelsandexamrequest`,
		});
		const { data } = await response;

		exams = data.RECORDS;
	} catch (e) {
		Message.error();
	}
  
	return exams;
}